<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync
                    :app="app"
                    :view="view"
                    :columns="columns"
                    :default-limit="20"
                    :required-filters="routeFilter"
                    pagination="loadmore"
                    @edit="openForm"
                >
                    <template slot="provider_name" slot-scope="{ item }">
                        <truncate
                            v-if="item.provider"
                            tag="span"
                            class="clickable"
                            @click="$router.push(`/providers/${item.provider._EntityId}`)"
                        >
                            {{ item.provider.name }}
                        </truncate>
                        <span v-else>Sin asignar</span>
                    </template>

                    <template slot="total" slot-scope="{ item }">
                        <span>{{ item.total ? item.total + ' €' : '' }}</span>
                    </template>

                    <template slot="status" slot-scope="{ item }">
                        <g-select
                            :item="item._EntityId"
                            :app="app"
                            name="status"
                            :colors="[$colors.blue, $colors.orange, $colors.success]"
                            block
                        />
                    </template>

                    <template slot="payment_method" slot-scope="{ item }">
                        <g-select
                            :item="item._EntityId"
                            :app="app"
                            name="payment_method"
                            :colors="[$colors.blue]"
                            block
                        />
                    </template>

                    <template slot="factura" slot-scope="{ item }">
                        <g-upload
                            accept=".pdf"
                            name="pdf"
                            app="expenses"
                            :item="item._EntityId"
                            :file-name="'factura_asociada_' + item._EntityId + '.pdf'"
                            folder-name="facturas_gastos"
                            :value="item.pdf"
                        />
                    </template>
                </g-table-sync>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Expenses',
    data() {
        return {
            app: 'expenses',
            view: 'expenseList',
            printing: false,
            xport: {
                enabled: false,
                loading: false,
                dates: [],
            },
            columns: [
                {
                    title: 'Serie',
                    index: 'serie',
                    order: true,
                    search: true,
                },
                {
                    title: 'Fecha',
                    index: 'bill_date',
                    order: true,
                    slot: '_date',
                    search: false,
                    date: true,
                },
                {
                    title: 'Proveedor',
                    index: 'rlt_providers_939.name',
                    order: false,
                    search: true,
                    slot: 'provider_name',
                },

                {
                    title: 'Importe',
                    index: 'total',
                    order: true,
                    slot: 'total',
                },
                {
                    title: 'Estado',
                    index: 'status',
                    slot: 'status',
                    order: true,
                },
                {
                    title: 'Metodo de pago',
                    index: 'payment_method',
                    order: true,
                    slot: 'payment_method',
                },
                {
                    title: 'Factura',
                    slot: 'factura',
                },

                {
                    title: 'Acciones',
                    slot: '_actions',
                },
            ],
        }
    },
    computed: {
        routeFilter() {
            if (this.$route?.query?.field && this.$route?.query?.value) {
                return [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {
                            [this.$route.query.field]: {
                                type: 3,
                                int: parseInt(this.$route.query.value, 10),
                                opt: '=',
                            },
                        },
                    },
                ]
            }
            return []
        },
    },
    created() {
        this.$hub.$on('newExpense', () => {
            this.$router.push({ name: 'expensesNew' })
        })
    },
    beforeDestroy() {
        this.$hub.$off('newExpense')
    },
    methods: {
        openForm(item) {
            this.$router.push({ name: 'expensesEdit', params: { id: item._EntityId } })
        },
    },
}
</script>

<style lang="scss"></style>
